export enum RecipientShieldResultType {    
    ABO         = 1,
    SEROLOGY    = 2,
    HLA         = 3,
    CREATININE  = 4,
    TRAC        = 5,
    TACROLIMUS  = 6,
    TRUGRAF     = 7
}